import { useTranslation } from "react-i18next";
import { BackgroundContact } from "../../components/background";
import Header from "../../components/header";
import PagesHeadLine from "../../components/pagesHeadline";
import Footer from "../../components/footer";
import Spacer from "../../components/spacer";
import Project from "../../components/projectComps/project";

import { projects as localProjects } from "../../data/projects";

import "./styles.css";

function ProjectsPage() {
  const { t } = useTranslation();
  const filteredProjects = localProjects.slice().sort((a, b) => a.order - b.order);

  return (
    <div className="App">
      <BackgroundContact />
      <div className="project-page-container">
        <Header />
        <PagesHeadLine content={t("projects.headline")}></PagesHeadLine>
        <div className="project-page-content-container">
          <div className="project-page-list-container">
            {filteredProjects.map((project) => (
              <Project project={project} key={project.slug} />
            ))}
          </div>
        </div>
        <Spacer space="6" />
        <Footer />
      </div>
    </div>
  );
}
export default ProjectsPage;
